import * as React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import { DigitalStylingOrderListItem } from '../../shared/types';

type DigitalStylingTableBodyLabels = {
    orderStatus: (displayName: string) => string;
};

type DigitalStylingTableBodyProps = {
    orders: DigitalStylingOrderListItem[];
    labels: DigitalStylingTableBodyLabels;
};

function formatFn(createdAt: string): string {
    return formatDate(new Date(createdAt), 'yyyy-MM-dd HH:mm');
}

export function DigitalStylingTableBody({ orders, labels }: DigitalStylingTableBodyProps) {
    return (
        <TableBody
            sx={{
                cursor: 'pointer'
            }}
        >
            {orders.map((order) => (
                <TableRow
                    sx={{
                        '&:hover': {
                            backgroundColor: '#f5f5f5'
                        }
                    }}
                    onClick={() => {
                        history.push(`/orders/${order.orderId}/digital-styling`);
                    }}
                    key={order.orderId}
                >
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            {order.orderNumber}
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            {order.brokerFirm}
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            {order.productName}
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            {order.address}
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            {labels.orderStatus(order.orderStatus.displayName)}
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            <time dateTime={formatFn(order.createdAt)}>
                                {formatFn(order.createdAt)}
                            </time>
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            {order.photoTime && (
                                <time dateTime={formatFn(order.photoTime)}>
                                    {formatFn(order.photoTime)}
                                </time>
                            )}
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link className="nolink" to={`/orders/${order.orderId}/digital-styling`}>
                            {order.assignedUser}
                        </Link>
                    </TableCell>
                </TableRow>
            ))}
        </TableBody>
    );
}
